import { useT } from '../i18n';
import { Modal } from './Modal';

interface Props {
  title: string;
  body: string;
  /** Defaults to the generic "Confirm" — pass the verb for the actual action. */
  confirmLabel?: string;
  /** Defaults to "Cancel" — pass a clearer one when the action itself is a cancel. */
  dismissLabel?: string;
  /** Paints the confirm button red, for anything that destroys or signs out. */
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * A yes/no dialog for actions that are easy to hit and annoying to undo.
 *
 * The heavier flows — deleting an account, cancelling a paid booking — keep
 * their own modals, because they have refund figures and consequences to
 * explain. This is for the ones where a sentence is the whole story.
 */
export function ConfirmModal({ title, body, confirmLabel, dismissLabel, danger, onConfirm, onClose }: Props) {
  const { t } = useT();

  return (
    <Modal title={title} onClose={onClose} maxWidth={400}>
      <p className="muted" style={{ marginTop: 4 }}>
        {body}
      </p>
      <div className="form-actions">
        <button type="button" className="btn ghost" onClick={onClose}>
          {dismissLabel ?? t('cancel')}
        </button>
        <button type="button" className={`btn${danger ? ' bad' : ''}`} onClick={onConfirm}>
          {confirmLabel ?? t('confirm')}
        </button>
      </div>
    </Modal>
  );
}
